let triggers = document.body.querySelectorAll('[data-tooltip="trigger"]')

if (window.matchMedia('(min-width: 1000px)').matches) {
  triggers.forEach(function(el) {
    el.addEventListener('mousedown', function(e) {
      e.preventDefault()
    })
  })
}
